import router from '../router/router';

const mutations = {
    changeTitle(state, title) {
        state.title = title;
    },
    changeSelectTab(state, { selectVal, userId }) {
        state.selectTab = selectVal.split('/')[1];
        router.push(`${selectVal}`);
    },
    selectFansBy(state, selectFansBy) {
        state.fansBy = selectFansBy;
    },
    selectRankBy(state, selectRankBy) {
        state.rankBy = selectRankBy;
    },
    setShowFooter(state, value) {
        state.showFooter = value;
    }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/mutations/interface.js